import React, { useEffect, useState } from 'react';
import { FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
// import { useSelector, useDispatch } from 'react-redux';
import NumberFormat from 'react-number-format';

import '../style/cobros.css';
import iconExclamacion from '../style/iconExclamacion.svg';
import iconExclamacionExcede from '../style/iconExclamacionExcede.svg';
import iconExclamacionAbono from '../style/iconExclamacionAbono.svg';
/* import iconPagar from '../style/iconPagar.svg'; */

import { Buy } from '../../../models/buy';
import { useCobros } from '../../../hooks/useCobros';

import { emit } from "../../../utils/eventBus";
import { Save } from 'lucide-react';

export const CobrosForm = ({ setModal, initialData, checkInitialData }) => {

    const [showAccount, setShowAccount] = useState(false)
    const [tiposDePagos, setTiposDePagos] = useState([])
    const [cuentasBancarias, setCuentasBancarias] = useState([])
    const [msgError, setMsgError] = useState('')

    const { initSaveCobro, initUpdateCobro } = useCobros()
    const [form, setForm] = useState(initialData)

    useEffect(() => {
        getInfoBancaria()
    }, [])

    const getInfoBancaria = async () => {
        const dataResult = await Buy.getInfoBancaria()
        setTiposDePagos(dataResult.tipos_pagos)
        setCuentasBancarias(dataResult.ctas_bancarias)
    }

    const handleChange = ({ target }) => {
        setForm({
            ...form,
            [target.name]: target.value
        });
    }

    const handleChangeDate = (date) => {
        setForm({
            ...form,
            'fecha_cobro': date,
        });
    }

    const handleChangeMonto = (value) => {
        setForm({
            ...form,
            'total_cobro': value.floatValue,
        });
    }

    const handleSave = async () => {

        if (form.total_cobro === 0) {
            setMsgError('Ingrese un monto válido')
            return false
        }

        if (form.id === 0) {
            await initSaveCobro(form)
        }

        if (form.id > 0) {
            await initUpdateCobro(form)
        }

        emit("flows_updated");
        emit("invoice_updated");

        setModal(false)

    }

    return (
        <div className="row p-dialog-form">
            <div className="col">

                <div className="row">
                    <div className="col">
                        <TextField
                            label="Cliente"
                            disabled={true}
                            name="cliente"
                            id="outlined-size-small"
                            value={form?.cliente || ''}
                            size="small"
                            fullWidth
                            placeholder='Cliente'
                            onChange={handleChange}
                        />
                    </div>
                </div>

                <div className="row">
                    <div className="col">

                        {form?.id > 0 ?
                            <NumberFormat
                                disabled={true}
                                className={`text-end monto normal`}
                                value={form?.total_cobro}
                                thousandSeparator={form?.separacion_miles}
                                decimalSeparator={form?.separacion_decimales}
                                prefix={`${form?.simbolo} `}
                                onValueChange={(values) => handleChangeMonto(values, 'total_cobro')}
                                decimalScale={2}
                                fixedDecimalScale
                            />
                            :
                            <NumberFormat
                                disabled={form?.id > 0 ? true : false}
                                className={`text-end monto ${form.total_cobro > form.factura_total_por_cobrar ? ' excede' : (form.total_cobro < form.factura_total_por_cobrar ? 'abono' : 'normal')}`}
                                value={form.total_cobro}
                                thousandSeparator={form.separacion_miles}
                                decimalSeparator={form.separacion_decimales}
                                prefix={`${form.simbolo} `}
                                onValueChange={(values) => handleChangeMonto(values, 'total_cobro')}
                                decimalScale={2}
                                fixedDecimalScale
                            />

                        }

                        <span className='info d-flex justify-content-start align-items-center'>

                            {(form.total_cobro === form.total_por_cobrar && form.id === 0) &&
                                <>
                                    <img src={iconExclamacion} alt="pago total" />
                                    <label className='normal'>Puedes abonar el monto completo o de forma parcial</label>
                                </>
                            }

                            {(form.total_cobro > form.total_por_cobrar && form.id === 0) &&
                                <>
                                    <img src={iconExclamacionExcede} alt="excede total" />
                                    <label className='excede'>El monto ingresado sobrepasa el total de la factura</label>
                                </>
                            }

                            {(form.total_cobro < form.total_por_cobrar && form.id === 0) &&
                                <>
                                    <img src={iconExclamacionAbono} alt="pago parcial" />
                                    <label className='abono'>El monto ingresado es un abono del total de la factura</label>
                                </>
                            }

                        </span>
                    </div>
                </div>

                <div className="row mt-4">
                    <div className="col">
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DesktopDatePicker
                                label="Fecha de cobro"
                                inputFormat="dd/MM/yyyy"
                                name="fecha_cobro"
                                value={form.fecha_cobro || ''}
                                onChange={handleChangeDate}
                                renderInput={(params) => <TextField {...params} />}
                            />
                        </LocalizationProvider>
                    </div>
                </div>

                {showAccount &&
                    <>
                        <div className="row">
                            <div className="col">
                                <FormControl fullWidth size="small">
                                    <InputLabel id="demo-simple-select-label">Tipo de cobro</InputLabel>
                                    <Select
                                        label="Tipo de cobro"
                                        id="id_tipo_cobro"
                                        name="id_tipo_cobro"
                                        value={form.id_tipo_cobro || ''}
                                        onChange={handleChange}
                                        className='p-list-capitalize'
                                    >
                                        <MenuItem value='' key=''>Ninguno</MenuItem>
                                        {tiposDePagos.map(item => (
                                            <MenuItem value={item.id} key={item.id}>{item.nombre}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>

                            </div>
                        </div>

                        <div className="row">
                            <div className="col">
                                <FormControl fullWidth size="small">
                                    <InputLabel id="demo-simple-select-label">Cuenta bancaria</InputLabel>
                                    <Select
                                        label="Cuenta bancaria"
                                        id="id_cuenta"
                                        name="id_cta_bancaria"
                                        value={form.id_cta_bancaria || ''}
                                        onChange={handleChange}
                                        className='p-list-capitalize'
                                    >
                                        <MenuItem value='' key=''>Ninguno</MenuItem>
                                        {cuentasBancarias.map(item => (
                                            <MenuItem value={item.id} key={item.id}>{item.nombre}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>

                            </div>
                        </div>

                        <div className="row">
                            <div className="col">
                                <TextField
                                    label="N° de operación"
                                    name="nro_operacion"
                                    id="outlined-size-small"
                                    value={form.nro_operacion || ''}
                                    size="small"
                                    fullWidth
                                    placeholder='Ingrese número operación'
                                    onChange={handleChange}
                                />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col ">
                                <div style={{ fontSize: '14px' }}>Adjunta enlace del boucher de cobro (opcional)</div>
                                <div style={{ fontSize: '14px', color: 'gray' }}>Te facilita el seguimiento para futuras revisiones.</div>
                                <div className='mt-2'>
                                    <input
                                        type="url"
                                        style={{
                                            width: '100%',
                                            border: '0px',
                                            borderBottom: '1px solid lightgray',
                                            padding: '5px',
                                            fontSize: '13px',
                                            outline: 'none'
                                        }}
                                        onChange={handleChange}
                                        placeholder='Ingrese enlace del archivo'
                                        name="url_boucher"
                                        value={form?.url_boucher || ''}
                                    />
                                </div>
                            </div>
                        </div>

                    </>
                }

                {msgError !== '' &&
                    <div className='mt-2' style={{ color: 'red' }}>{msgError}</div>
                }

                <div className="row d-flex align-items-center">
                    <div className="col-7 agregar-datos" onClick={() => setShowAccount(!showAccount)}>
                        {showAccount ? 'Ocultar datos bancarios' : 'Agregar datos bancarios'}
                    </div>
                    <div className="col-5">
                        <button className='btn w-100 flex items-center justify-center' onClick={handleSave}>
                            <Save className='w-5 h-5 text-white' />
                            <label>{form.id > 0 ? 'Actualizar' : 'Cobrar'}</label>
                        </button>
                    </div>
                </div>


            </div>
        </div>
    )

}